 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER_PA from '@/components/html/00_Cover_Pa'
 import HTML00_FRONT_MA from '@/components/html/00_Front_Ma'
 import HTML01_TITLE_PA from '@/components/html/01_Title_pa'
 import HTML02_COPYRIGH from '@/components/html/02_Copyrigh'
 import HTML01_CONTENT from '@/components/html/01_Content'
 import HTML04_ACKNOWLE from '@/components/html/04_Acknowle'
 import HTML01_INTRODUC from '@/components/html/01_Introduc'
 import HTML02_CHAPTER from '@/components/html/02_Chapter'
 import HTML03_CHAPTER from '@/components/html/03_Chapter'
 import HTML04_CHAPTER from '@/components/html/04_Chapter'
 import HTML05_CHAPTER from '@/components/html/05_Chapter'
 import HTML06_CONCLUSI from '@/components/html/06_Conclusi'
 import HTML07_WORKS_CI from '@/components/html/07_Works_Ci'
 import HTML08_SUBJECT from '@/components/html/08_Subject'
 import HTML09_TELEVISI from '@/components/html/09_Televisi'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/01_Content",
 			"name" : "html/01_Content",
 			"component" : HTML01_CONTENT
 		},
 		{
 			"path" : "/html/04_Acknowle",
 			"name" : "html/04_Acknowle",
 			"component" : HTML04_ACKNOWLE
 		},
 		{
 			"path" : "/html/01_Introduc",
 			"name" : "html/01_Introduc",
 			"component" : HTML01_INTRODUC
 		},
 		{
 			"path" : "/html/02_Chapter",
 			"name" : "html/02_Chapter",
 			"component" : HTML02_CHAPTER
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js